export type CreateContactRequestPayload = {
    type: string;
    name: string;
    email: string;
    message?: string;
    metadata?: Record<string, any>;
};

const base = process.env.REACT_APP_MASHOORAH_API_URL;

export async function createContactRequest(payload: CreateContactRequestPayload): Promise<void> {
    if (!base) throw new Error('Missing REACT_APP_MASHOORAH_API_URL');

    const res = await fetch(`${base}/contact-requests`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    });

    if (!res.ok) {
        const text = await res.text();
        throw new Error(text || 'Failed to submit');
    }
}

export async function submitDemoRequest(params: {
    name: string;
    email: string;
    companySize?: string | null;
    message?: string;
}): Promise<void> {
    const { name, email, companySize, message } = params;
    return createContactRequest({
        type: 'demo-request',
        name,
        email,
        message: message || undefined,
        metadata: companySize ? { companySize } : undefined,
    });
}


